var Racer = require('./Racer');
module.exports = new Racer;
